export default "__VITE_ASSET__b1b7b86b__"